import { defineStore } from 'pinia'
import { ref } from 'vue'
import useApiFetch from '@/composables/useApi'
import { useRouter } from 'vue-router'

export const useAuthStore = defineStore('authStore', () => {
  const router = useRouter()

  const token = ref(localStorage.getItem('token') || '')
  const error = ref('')
  const isChecking = ref(false)

  const userForm = ref({
    email: '',
    password: '',
  })

  const login = async () => {
    isChecking.value = true
    error.value = ''

    const { data, error: fetchError } = await useApiFetch('/auth', {
      method: 'POST',
      body: JSON.stringify(userForm.value),
    })

    if (!fetchError.value && data.value?.token) {
      localStorage.setItem('token', data.value.token)
      token.value = data.value.token
      await router.push('/')
    } else {
      if (fetchError.value?.status === 401) {
        error.value = 'Credenciais inválidas'
      } else {
        error.value = 'Erro ao tentar login'
      }
    }

    isChecking.value = false
  }

  const logout = () => {
    localStorage.removeItem('token')
    token.value = ''
    router.push('/auth/login')
  }

  const isLoggedIn = () => !!token.value

  return {
    userForm,
    token,
    error,
    isChecking,
    login,
    logout,
    isLoggedIn,
  }
})
